export enum ELocalStorage {
  AM_AUTH = 't_shirt_cafe_authorization',
  DEFAULT_AM_AUTH = 't_shirt_cafe_default_authorization',
  USER = 't_shirt_cafe_user',
  THEME = 't_shirt_cafe_theme',
  CART = 't_shirt_cafe_cart',
  WISHLIST = 't_shirt_cafe_wishlist',
  RECENT_SEARCHES = 't_shirt_cafe_recent_searches',
}
